import SubscriptionResource from "../../resources/subscription-resource"

export const makeSubscriptionResource = (): SubscriptionResource => {
    return new SubscriptionResource()
}
